// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  npcId: __t.string().primaryKey(),
  lobbyId: __t.string(),
  teamId: __t.i32(),
  laneId: __t.string(),
  posX: __t.i32(),
  posY: __t.i32(),
  velX: __t.i32(),
  velY: __t.i32(),
  health: __t.f32(),
  maxHealth: __t.f32(),
  radius: __t.f32(),
  waveNumber: __t.u16(),
  updatedAt: __t.timestamp(),
});
